import { styled } from "../../../../styles/stitches.config"
import { Flex } from "../../../../components/flex/Flex"
import Card from "../../../../components/Card"

export const SContainer = styled(Flex, {
  [`& ${Card}`]: {
    flex: 1,
  },
})
